// src/pwa/install.js — PWA yükleme durumu (beforeinstallprompt tek yerden yakalanır)
import { useEffect, useState } from 'react';

let deferred = null;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn());

export const isIos = () => typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent || '') && !/crios|fxios/i.test(navigator.userAgent || '');
export const isMobile = () => typeof navigator !== 'undefined' && /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent || '');
export const isStandalone = () => typeof window !== 'undefined' && (window.matchMedia?.('(display-mode: standalone)').matches || navigator.standalone === true);

/** index.js içinde bir kez çağrılır: olay React yüklenmeden önce de yakalanır. */
export function initInstallCapture() {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e;
    emit();
  });
  window.addEventListener('appinstalled', () => {
    deferred = null;
    emit();
  });
}

/** Tarayıcının yükleme penceresini açar. Dönüş: 'accepted' | 'dismissed' | 'unavailable' */
export async function promptInstall() {
  if (!deferred) return 'unavailable';
  const e = deferred;
  deferred = null;
  e.prompt();
  const r = await e.userChoice.catch(() => null);
  emit();
  return (r && r.outcome) || 'dismissed';
}

export function useInstall() {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((x) => x + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  return { canPrompt: !!deferred, ios: isIos(), mobile: isMobile(), installed: isStandalone() };
}

/** Tarayıcıya göre "ana sayfam yap" adımları */
export function homepageSteps() {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  if (/edg\//i.test(ua)) return { browser: 'Microsoft Edge', steps: ['Sağ üstteki ⋯ menüsünden Ayarlar’ı açın.', 'Başlangıç, giriş ve yeni sekmeler bölümüne gidin.', '“Bu sayfaları aç” seçeneğini işaretleyip https://oyuntu.com adresini ekleyin.'] };
  if (/firefox|fxios/i.test(ua)) return { browser: 'Firefox', steps: ['Menüden (☰) Ayarlar’ı açın ve Giriş sekmesine geçin.', '“Ana sayfa ve yeni pencereler” için “Özel adresler”i seçin.', 'https://oyuntu.com adresini yazın. Ya da bu sekmeyi araç çubuğundaki ev simgesine sürükleyin.'] };
  if (/safari/i.test(ua) && !/chrome|crios|android/i.test(ua)) return { browser: 'Safari', steps: ['Safari menüsünden Ayarlar’ı (Tercihler) açın.', 'Genel sekmesinde “Ana sayfa” alanına https://oyuntu.com yazın.', 'iPhone ve iPad’de Paylaş → Ana Ekrana Ekle ile Oyuntu’yu ana ekrana koyabilirsiniz.'] };
  if (/android/i.test(ua)) return { browser: 'Android', steps: ['Tarayıcı menüsünden (⋮) Ayarlar → Ana sayfa’yı açın.', 'Özel sayfa olarak https://oyuntu.com adresini girin.', 'Daha da kolayı: “Uygulamayı yükle” ile Oyuntu’yu ana ekranınıza ekleyin.'] };
  return { browser: 'Google Chrome', steps: ['Sağ üstteki ⋮ menüsünden Ayarlar’ı açın.', '“Başlangıçta” bölümünde “Belirli bir sayfayı veya sayfa grubunu aç”ı seçin.', '“Yeni sayfa ekle” ile https://oyuntu.com adresini ekleyin. İsterseniz Görünüm → “Ana sayfa düğmesini göster” ile de aynı adresi girin.'] };
}
